import classNames from 'classnames/bind';
import Box from 'src/components/ui-kit/box/box';
import { ButtonSize, ButtonVariant } from 'src/components/ui-kit/button/button';
import ButtonBlock from 'src/components/ui-kit/button/__block';
import FormTextInput from 'src/components/ui-kit/form/_text-input';
import { useFormik } from 'formik';
import { RestorePasswordForm } from 'src/forms/restore-password';
import { useTranslation } from 'next-i18next';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './restore-password.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RestorePasswordPageActions, RestorePasswordPageSelectors } from 'src/store/pages/restore-password';
import useServerError from 'src/hooks/use-server-error';

const classesContext = classNames.bind(styles);

export default function RestorePassword({
  className,
  ...restProps
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element {
  const { t } = useTranslation(['components:pages:restore-password']);

  const dispatch = useDispatch();
  const isSending = useSelector(RestorePasswordPageSelectors.isSending);
  const error = useSelector(RestorePasswordPageSelectors.error);

  const initialValues = new RestorePasswordForm();
  const validationSchema = RestorePasswordForm.getValidationSchema(t);

  const handleSubmit = (values: RestorePasswordForm): void => {
    dispatch(RestorePasswordPageActions.forgotPassword({ email: values.email }));
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
    validationSchema
  });

  useServerError<RestorePasswordForm>(formik, error);

  return (
    <Box
      className={classesContext(['restorepassword', className])}
      {...restProps}>
      <h1 className={styles.restorepassword_title}>{t('TEXT_RESTORE_PASSWORD')}</h1>
      <form
        onSubmit={formik.handleSubmit}
        className={styles.restorepassword_form}>
        <div className={styles.restorepassword_description}>{t('TEXT_PLEASE_ENTER_YOUR_EMAIL')}</div>
        <FormTextInput<RestorePasswordForm>
          name='email'
          type='email'
          placeholder={t('TEXT_EMAIL_ADDRESS')}
          isBordered
          formik={formik}
          className={styles.restorepassword_field}
        />
        <div className={styles.restorepassword_actions}>
          <ButtonBlock
            type='submit'
            isLoading={isSending}
            disabled={!formik.isValid && !!formik.submitCount}
            variant={ButtonVariant.SECONDARY}
            size={ButtonSize.LARGE}
          >
            {t('BUTTON_SUBMIT')}
          </ButtonBlock>
        </div>
      </form>
    </Box>
  );
}
